import { IGLAccountState } from '@/store/accounting';
import { IGLAccountGetters } from './getters.types';
import { IGLAccount, GLAccount, IDepartmentData } from '@/models';

export const getters: IGLAccountGetters = {
  getGLAccounts(state: IGLAccountState): IGLAccount[] {
    return state.accounts.map(data => new GLAccount(data));
  },

  getGLAccountById: (state: IGLAccountState) => (
    id: number
  ): IGLAccount | undefined => {
    const data = state.accounts.find(account => account.id === id);
    if (!data) {
      return undefined;
    }

    return new GLAccount(data);
  },

  getGLAccountsByDepartment: (state: IGLAccountState) => (
    department: number
  ): IGLAccount[] => {
    const accounts = state.accounts.filter(account => {
      // If length of departments is truthy then return this account
      return account.departments.filter(accountDepartment => {
        return (accountDepartment as IDepartmentData).id == department;
      }).length;
    });

    return accounts.map(data => new GLAccount(data));
  }
};
